import { IsomorphicIcon, StatCard, StatCardsRow } from '@v2/design-system';
import type { ShipmentStats as Stats } from './types';

function formatBrl(value: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(
        value,
    );
}

export default function ShipmentStats({ stats, loading }: { stats?: Stats; loading: boolean }) {
    const cards = [
        {
            count: loading ? '—' : (stats?.registered_open ?? 0),
            label: 'Processos abertos',
            icon: <IsomorphicIcon name="ship-with-container" />,
        },
        {
            count: loading ? '—' : (stats?.delivered_month ?? 0),
            label: 'Entregues no mês',
            icon: <IsomorphicIcon name="shipping-box" />,
        },
        {
            count: loading ? '—' : (stats?.in_transit ?? 0),
            label: 'Em trânsito',
            icon: <IsomorphicIcon name="cargo-pallet" />,
        },
        {
            count: loading ? '—' : formatBrl(stats?.freight_open_brl ?? 0),
            label: 'Frete em aberto (BRL)',
            icon: <IsomorphicIcon name="money-in-hand" />,
        },
        {
            count: loading ? '—' : (stats?.total ?? 0),
            label: 'Total de embarques',
            icon: <IsomorphicIcon name="containers" />,
        },
    ];

    return (
        <StatCardsRow>
            {cards.map((item) => (
                <StatCard key={item.label} count={item.count} label={item.label} icon={item.icon} />
            ))}
        </StatCardsRow>
    );
}
